var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 456,
    height: 423,
    viewBox: "0 0 456 423",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_828_3004)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M277.92 120.999C260.942 109.383 234.986 123.868 220.876 133.654C220.907 133.685 220.953 133.716 220.984 133.763C222.054 134.988 220.069 138.353 219.697 138.958C218.302 141.331 216.674 143.192 214.875 144.758C224.132 145.192 234.675 147.364 244.676 153.21C253.608 148.604 258.895 144.789 262.043 147.209C264.306 148.946 262.663 151.737 262.988 165.85C263.035 168.13 263.128 170.255 263.252 172.286C266.462 179.56 267.345 188.214 266.152 197.643C266.694 201.07 267.361 204.916 268.183 209.088C270.71 210.5 273.238 211.895 275.765 213.307C280.417 206.126 286.65 194.479 289.379 179.063C290.681 171.728 297.302 134.243 277.92 120.983V120.999Z",
    fill: "url(#paint0_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.105 215.835C269.376 215.338 269.066 214.408 269.345 213.57C269.423 213.322 269.516 213.043 269.624 212.749C268.802 213.074 267.996 213.586 267.841 214.346C267.5 215.959 267.159 217.665 268.492 222.069C269.826 226.474 269.671 228.35 271.283 228.645C272.601 228.878 274.943 221.061 273.268 215.509C272.446 216.378 271.113 216.533 270.12 215.835H270.105Z",
    fill: "#26264F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.4 210.329C270.369 210.608 269.423 213.322 269.346 213.57C269.067 214.408 269.377 215.323 270.105 215.835C271.098 216.517 272.431 216.362 273.253 215.509C273.315 215.447 274.152 214.734 275.129 212.966L270.4 210.329Z",
    fill: "#26264F"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M202.997 180.723C202.548 181.56 202.098 182.429 201.648 183.313C202.098 182.46 202.548 181.591 202.997 180.723Z",
    fill: "url(#paint1_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M180.654 229.157L169.629 232.894C162.047 235.469 153.752 234.709 146.759 230.831L103.142 206.607C98.0562 203.784 96.6763 197.643 99.0641 193.052C98.723 193.238 98.3974 193.44 98.0562 193.642C91.2959 197.596 91.4354 207.429 98.2888 211.228L141.906 235.453C148.899 239.33 157.21 240.09 164.776 237.516L179.475 232.537C179.677 231.731 179.972 230.925 180.22 230.273C180.359 229.932 180.499 229.56 180.654 229.172V229.157Z",
    fill: "url(#paint2_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M332.467 50.543C331.506 50.7291 329.955 51.1323 328.312 51.6441C314.062 55.909 299.89 62.5777 286.726 72.5498C252.227 98.682 224.813 140.23 206.299 174.52C206.33 174.52 206.377 174.551 206.408 174.566C205.478 176.148 204.485 177.931 203.462 179.855C203.307 180.149 203.152 180.428 202.997 180.723C202.547 181.592 202.097 182.46 201.648 183.313C192.298 201.551 180.762 228.893 180.653 229.157C180.498 229.544 180.359 229.917 180.219 230.258C179.956 230.909 179.661 231.716 179.475 232.522C179.366 232.956 179.289 233.406 179.258 233.809C186.809 229.095 208.656 242.107 229.263 263.85C250.102 285.826 261.964 308.623 256.413 315.633C256.971 315.695 257.591 315.633 258.212 315.54C259.049 315.401 259.902 315.137 260.599 314.904C260.91 314.796 261.251 314.687 261.623 314.563C269.67 311.865 288.835 305.087 312.062 294.402C313.861 293.58 315.69 292.727 317.536 291.843C352.748 275.171 395.683 250 423.608 216.92C435.268 203.118 443.021 187.857 447.998 172.395C442.06 150.559 421.918 121.418 401.947 100.341C381.976 79.2651 356.547 59.1348 332.452 50.512L332.467 50.543ZM382.519 212.128C358.082 235.298 317.427 232.088 291.688 204.948C265.949 177.807 264.91 137.02 289.347 113.85C313.783 90.6795 354.439 93.8898 380.178 121.03C405.901 148.17 406.956 188.958 382.519 212.128Z",
    fill: "url(#paint3_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M280.029 393.192L258.167 348.341C254.662 341.145 254.352 332.817 257.314 325.388L261.624 314.579C261.268 314.703 260.926 314.811 260.601 314.92C259.903 315.152 259.05 315.401 258.213 315.556L252.445 330.01C249.483 337.438 249.778 345.782 253.298 352.963L275.16 397.814C278.587 404.855 288.402 405.522 292.713 398.977C292.93 398.651 293.131 398.326 293.348 398C288.635 400.14 282.572 398.434 280.029 393.208V393.192Z",
    fill: "url(#paint4_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M317.551 291.858C315.706 292.727 313.876 293.58 312.078 294.417C288.85 305.087 269.686 311.88 261.638 314.579L257.328 325.388C254.366 332.817 254.661 341.161 258.181 348.341L280.043 393.192C282.586 398.419 288.649 400.125 293.362 397.984C295.006 397.24 296.479 396.03 297.58 394.355C326.451 350.559 323.707 313.524 317.551 291.858Z",
    fill: "url(#paint5_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M203.463 179.839C204.486 177.916 205.479 176.132 206.409 174.55C206.378 174.55 206.331 174.519 206.3 174.504C205.324 176.303 204.378 178.071 203.463 179.839Z",
    fill: "#00EDD5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M203.463 179.839C204.486 177.916 205.479 176.132 206.409 174.55C206.378 174.55 206.331 174.519 206.3 174.504C205.324 176.303 204.378 178.071 203.463 179.839Z",
    fill: "url(#paint6_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M102.91 189.02C101.173 190.044 99.8865 191.455 99.0647 193.052C96.6768 197.643 98.0568 203.784 103.143 206.607L146.759 230.832C153.752 234.709 162.063 235.469 169.63 232.894L180.654 229.157C180.763 228.893 192.299 201.567 201.649 183.313C202.098 182.429 202.548 181.56 202.998 180.723C203.153 180.428 203.308 180.134 203.463 179.854C204.378 178.102 205.324 176.318 206.3 174.519C184.996 167.215 148.17 162.516 102.91 189.02Z",
    fill: "url(#paint7_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M202.998 180.723C203.153 180.428 203.309 180.134 203.464 179.854C203.309 180.149 203.153 180.444 202.998 180.723Z",
    fill: "#00EDD5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M202.998 180.723C203.153 180.428 203.309 180.134 203.464 179.854C203.309 180.149 203.153 180.444 202.998 180.723Z",
    fill: "url(#paint8_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M269.299 47.8909L272.012 45.27C274.059 43.3469 276.23 41.4083 278.54 39.4387C281.92 36.5851 285.223 33.9951 288.417 31.6533C288.417 31.6533 289.084 33.0181 287.285 34.9722C285.487 36.9418 281.905 39.8884 281.036 40.6329C280.153 41.3773 283.285 44.2154 281.44 47.5963C279.594 50.9772 275.113 51.2098 273.516 49.6434L272.229 50.8841L269.299 47.8599V47.8909Z",
    fill: "url(#paint9_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.419 248.62C241.419 248.62 239.9 248.496 240.148 246.449L240.334 244.913C239.404 245.084 238.101 245.518 237.217 246.867C235.837 249.008 236.318 253.645 237.093 259.181C237.869 264.718 240.567 259.678 240.83 258.825C241.078 257.972 243.761 246.34 243.761 246.34L243.637 246.263L241.435 248.604L241.419 248.62Z",
    fill: "url(#paint10_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.552 243.037L240.148 246.449C239.9 248.496 241.42 248.62 241.42 248.62L244.552 245.27L240.552 243.037Z",
    fill: "url(#paint11_linear_828_3004)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M268.523 47.0845C267.36 47.9375 265.593 49.1937 263.422 50.6515C245.374 62.6552 230.969 66.0361 213.572 72.5498C207.85 74.69 200.315 77.7452 191.694 81.8395C191.585 81.9946 191.461 82.2427 191.244 82.5839C193.446 82.3358 195.012 82.3513 196.299 82.7235C205.23 85.36 212.006 96.4797 212.068 106.405C212.068 106.902 212.037 107.491 211.975 108.173C215.557 106.204 220.301 101.815 227.806 94.8358C239.916 83.5454 237.776 83.8401 243.296 79.6372C255.607 70.2545 263.686 70.8128 269.237 61.6471C271.609 57.739 272.4 53.8773 272.725 51.4269C271.33 49.9846 269.934 48.5268 268.539 47.0845H268.523Z",
    fill: "url(#paint12_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M210.238 148.047C210.285 148.015 210.332 147.984 210.379 147.969C210.332 148 210.285 148.031 210.238 148.047Z",
    fill: "url(#paint13_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M211.371 147.349C211.418 147.318 211.48 147.287 211.527 147.24C211.48 147.271 211.418 147.302 211.371 147.349Z",
    fill: "url(#paint14_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M214.207 145.317C214.254 145.27 214.316 145.224 214.363 145.192C214.316 145.239 214.254 145.286 214.207 145.317Z",
    fill: "url(#paint15_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M210.379 147.952C210.518 147.875 210.657 147.782 210.796 147.689C210.657 147.782 210.518 147.86 210.379 147.952Z",
    fill: "url(#paint16_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M198.223 154.312C201.51 152.451 204.75 151.008 207.79 149.411C204.766 151.008 201.51 152.451 198.223 154.312Z",
    fill: "url(#paint17_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M209.061 148.713C209.464 148.496 209.852 148.263 210.24 148.031C209.852 148.263 209.464 148.48 209.061 148.713Z",
    fill: "url(#paint18_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M207.82 149.396C208.007 149.303 208.209 149.194 208.395 149.085C208.209 149.194 208.022 149.287 207.82 149.396Z",
    fill: "url(#paint19_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M213.867 145.595C213.991 145.502 214.099 145.409 214.223 145.317C214.115 145.409 213.991 145.502 213.867 145.595Z",
    fill: "url(#paint20_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M214.379 145.178C214.55 145.038 214.721 144.898 214.876 144.758C214.705 144.898 214.55 145.038 214.379 145.178Z",
    fill: "url(#paint21_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M212.084 146.884C212.27 146.759 212.441 146.635 212.628 146.511C212.457 146.635 212.27 146.759 212.084 146.884Z",
    fill: "url(#paint22_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M263.252 172.302C262.461 170.518 261.531 168.812 260.461 167.215C256.615 161.477 251.499 157.785 248.863 155.924C247.483 154.947 246.072 154.048 244.676 153.226C234.675 147.379 224.131 145.208 214.875 144.774C214.704 144.913 214.549 145.053 214.379 145.192C214.332 145.239 214.27 145.285 214.223 145.316C214.115 145.41 213.991 145.503 213.867 145.596C213.805 145.642 213.743 145.689 213.681 145.735C213.572 145.828 213.448 145.906 213.34 145.999C213.278 146.045 213.216 146.092 213.154 146.138C213.03 146.231 212.89 146.325 212.766 146.418C212.719 146.449 212.673 146.48 212.626 146.511C212.456 146.635 212.27 146.759 212.084 146.883C212.053 146.898 212.037 146.914 212.006 146.929C211.851 147.038 211.696 147.131 211.541 147.24C211.495 147.271 211.433 147.302 211.386 147.348C211.246 147.426 211.122 147.519 210.983 147.596C210.921 147.627 210.874 147.674 210.812 147.705C210.673 147.798 210.533 147.875 210.394 147.968C210.347 147.999 210.301 148.031 210.254 148.046C209.866 148.279 209.479 148.496 209.076 148.728C208.874 148.837 208.688 148.946 208.486 149.054C208.471 149.054 208.44 149.085 208.424 149.085C208.238 149.194 208.052 149.287 207.851 149.395H207.82C204.796 151.008 201.54 152.466 198.253 154.312C196.95 155.04 195.648 155.831 194.346 156.731C182.902 164.547 182.825 172.162 177.6 178.102C179.104 178.908 180.716 179.606 182.468 180.118C197.354 184.476 206.874 171.805 223.604 176.194C225.853 176.784 237.838 180.211 241.358 189.47C244.413 197.503 238.583 203.397 236.846 217.246C235.559 227.544 237.28 236.291 238.97 242.137C241.265 243.425 243.56 244.712 245.855 245.999C257.143 229.668 264.291 212.702 266.198 197.658C267.392 188.229 266.508 179.575 263.298 172.302H263.252Z",
    fill: "url(#paint23_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.509 145.239C118.632 145.192 104.383 145.022 96.258 133.514C89.2805 123.62 91.6684 112.221 92.1646 110.05C94.2423 109.414 96.3045 108.778 98.3822 108.127C100.258 110.655 103.995 114.873 109.872 116.594C119.067 119.293 127.719 114.191 134.587 110.003C144.542 103.939 142.449 101.567 152 95.1304C157.722 91.2687 165.428 88.4617 171.863 86.6006C172.979 85.9648 174.157 85.2979 175.119 84.7086C176.53 83.8246 177.445 81.2036 177.972 79.1409C180.515 80.6608 182.98 80.6608 182.98 80.6608V81.5448C182.965 82.5528 183.104 83.2817 183.445 83.8401C183.693 83.7935 183.895 83.7625 184.034 83.7315C186.298 83.3283 188.174 83.0026 189.756 82.7855C190.299 82.7079 190.795 82.6459 191.275 82.5839C191.896 81.5448 192.531 80.4747 193.167 79.4046C195.09 76.1633 198.423 70.363 196.64 64.3146C194.935 58.4988 189.012 54.0789 182.996 53.2104C181.523 52.9933 176.809 52.528 169.258 57.041C158.435 63.4926 160.078 73.108 151.659 75.8376C146.728 77.435 145.333 74.5504 137.285 76.2563C131.161 77.559 130.308 79.5752 125.501 81.1105C114.57 84.5845 110.554 76.7681 98.5993 78.6446C90.0248 79.9939 80.675 85.8097 79.2175 93.0522C78.3647 97.3016 81.0006 98.2011 81.2487 105.04C81.5433 112.996 78.1321 115.679 76.9692 122.969C75.8218 130.149 77.3879 138.555 81.2797 144.479C90.9551 159.243 114.089 157.367 116.601 157.119C128.881 155.956 136.975 150.171 147.628 142.354C151.411 139.578 154.9 136.353 158.373 132.475C157.768 130.227 156.946 128.366 156.28 127.047C154.776 129.11 142.387 145.487 122.524 145.255L122.509 145.239Z",
    fill: "url(#paint24_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.274 85.9337C189.088 85.9027 188.902 85.8716 188.701 85.8406C187.801 85.7166 185.956 85.2823 185.165 85.0342C184.344 84.786 183.786 84.4138 183.429 83.84C183.088 83.2817 182.948 82.5528 182.948 81.5447V80.6607C182.964 80.6607 180.514 80.6607 177.955 79.1409C177.428 81.219 176.513 83.84 175.102 84.7085C174.141 85.3133 172.978 85.9647 171.846 86.6006C169.939 87.6707 168.187 88.6322 167.908 88.9889C167.52 89.4697 179.087 90.7569 187.6 88.6942C189.212 88.3065 190.716 87.7947 192.003 87.1434C192.003 87.1434 192.034 86.4144 189.243 85.9337H189.274Z",
    fill: "url(#paint25_linear_828_3004)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M174.375 76.0391C174.375 76.0391 179.352 82.8319 187.136 79.9628C194.098 77.4039 189.88 59.4138 184.345 57.3821C182.5 56.6997 179.119 57.0099 176.856 58.4367C175.274 59.4293 171.041 64.7333 173.491 70.6421C171.723 70.1303 170.188 70.6111 169.801 71.4795C169.304 72.5807 170.808 74.085 171.15 74.4262C172.328 75.6049 173.739 75.9305 174.39 76.0391H174.375Z",
    fill: "url(#paint26_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6127 7.2116C68.7662 1.95415 57.7418 3.39646 51.1364 7.50627C43.3217 12.376 43.8799 18.7656 34.7627 20.8748C17.2105 24.9381 -2.35738 19.7581 0.232028 27.0317C2.54234 33.5454 15.1018 38.1204 14.373 51.6595C13.7993 62.221 14.8537 58.2042 11.0548 80.878C6.72882 93.3159 33.8013 85.6546 45.7716 80.056C62.2694 72.3482 69.9291 61.2594 81.8217 63.6788C87.3107 64.7954 90.4428 66.8426 93.3888 69.3395C90.1017 47.5963 87.7293 29.2495 84.6127 7.22711V7.2116Z",
    fill: "url(#paint27_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M289.346 113.849C264.91 137.019 265.964 177.807 291.688 204.948C317.411 232.088 358.082 235.298 382.519 212.128C406.955 188.958 405.901 148.17 380.177 121.03C354.454 93.8898 313.783 90.6795 289.346 113.849ZM373.122 202.218C353.617 220.72 321.148 218.161 300.603 196.495C280.059 174.83 279.221 142.261 298.727 123.76C318.233 105.258 350.702 107.817 371.246 129.482C391.791 151.148 392.628 183.716 373.122 202.218Z",
    fill: "url(#paint28_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M373.099 202.059C392.604 183.545 391.758 150.98 371.209 129.321C350.66 107.663 318.19 105.113 298.686 123.626C279.181 142.139 280.027 174.705 300.576 196.363C321.125 218.022 353.595 220.572 373.099 202.059Z",
    fill: "url(#paint29_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M189.523 289.734C189.089 288.865 188.066 288.632 186.484 288.803C184.546 289.005 181.739 289.827 178.142 290.835C176.855 291.191 175.46 291.579 173.956 291.982C164.559 294.464 151.163 297.193 134.277 295.456C112.88 293.254 104.879 285.856 93.0327 291.502C80.6438 297.395 84.6598 307.724 70.4878 319.836C52.9356 334.817 36.5153 327.823 28.2819 341.982C24.2505 348.93 22.917 359.74 27.8012 365.028C35.2904 373.108 54.8893 365.121 87.6678 353.769C107.577 346.883 121.811 339.641 127.176 336.834C147.581 326.164 169.661 311.709 181.352 301.334C182.36 300.435 183.29 299.566 184.143 298.744C186.918 296.015 188.779 293.688 189.446 291.905C189.771 291.036 189.818 290.292 189.523 289.718V289.734Z",
    fill: "url(#paint30_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M202.795 306.002C199.865 307.057 197.058 308.158 194.407 309.275C193.105 309.833 191.818 310.391 190.577 310.965C171.025 319.945 159.225 330.77 151.798 339.672C141.022 352.606 140.091 360.779 126.555 370.1C113.22 379.281 103.219 378.847 94.4588 390.463C92.5051 393.053 83.9306 404.42 87.5279 412.438C93.6215 426.024 133.409 427.342 161.784 411.229C167.35 408.065 188.934 395.813 192.407 375.156C194.112 365.059 190.143 360.919 189.848 348.698C189.616 339.175 191.725 328.629 197.601 317.122C198.206 315.928 198.873 314.718 199.57 313.493C200.811 311.322 202.175 309.135 203.695 306.902C204.067 306.359 204.455 305.801 204.842 305.258C204.16 305.49 203.478 305.739 202.811 305.971L202.795 306.002Z",
    fill: "url(#paint31_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M231.574 278.629L214.952 261.089C206.145 251.799 192.624 248.76 180.7 253.35C180.638 253.381 180.576 253.397 180.514 253.412L169.149 257.863C167.846 258.375 166.838 259.244 166.156 260.298C170.792 258.003 179.615 261.105 189.616 268.037C195.586 272.162 201.974 277.652 208.145 284.166C214.27 290.633 219.386 297.255 223.185 303.381C229.651 313.834 232.318 322.907 229.729 327.42C230.83 326.8 231.775 325.822 232.365 324.535L237.419 313.431C237.466 313.338 237.512 313.229 237.559 313.136C242.707 301.489 240.365 287.888 231.589 278.629H231.574Z",
    fill: "url(#paint32_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.096 303.18C186.701 301.706 185.383 300.233 184.127 298.744C183.274 299.566 182.344 300.435 181.336 301.334C182.623 302.807 183.956 304.296 185.352 305.77C187.073 307.584 188.81 309.321 190.562 310.98C191.802 310.407 193.089 309.848 194.392 309.29C192.283 307.429 190.174 305.382 188.096 303.18Z",
    fill: "url(#paint33_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.185 303.381C219.386 297.24 214.269 290.617 208.144 284.166C201.973 277.652 195.585 272.162 189.615 268.037C179.614 261.104 170.792 258.003 166.156 260.298C165.644 260.546 165.194 260.856 164.791 261.244C160.047 265.742 164.109 278.164 173.955 291.982C175.459 291.595 176.854 291.191 178.141 290.835C173.164 283.421 170.513 276.691 171.024 272.488C171.179 271.17 171.66 270.099 172.466 269.34C176.808 265.214 189.383 271.278 201.71 283.034C202.95 284.228 204.191 285.469 205.431 286.771C206.625 288.028 207.772 289.299 208.858 290.571C220.006 303.536 225.418 316.486 221.076 320.611C220.27 321.371 219.169 321.79 217.851 321.883C213.556 322.178 206.842 319.076 199.57 313.555C198.872 314.78 198.221 315.974 197.601 317.184C211.23 328.273 223.883 333.313 228.736 328.722C229.123 328.35 229.464 327.931 229.728 327.451C232.317 322.938 229.651 313.865 223.185 303.412V303.381Z",
    fill: "url(#paint34_linear_828_3004)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M208.843 290.556C207.758 289.284 206.61 288.012 205.416 286.756C204.191 285.453 202.936 284.213 201.695 283.018C189.368 271.263 176.809 265.214 172.452 269.324C171.646 270.084 171.18 271.154 171.01 272.472C170.498 276.675 173.15 283.391 178.127 290.819C181.724 289.811 184.531 288.989 186.469 288.788C188.05 288.617 189.074 288.85 189.508 289.718C189.787 290.292 189.756 291.036 189.43 291.905C188.764 293.673 186.903 296.015 184.127 298.744C185.383 300.218 186.701 301.706 188.097 303.18C190.175 305.382 192.299 307.414 194.392 309.29C197.059 308.158 199.85 307.057 202.78 306.018C203.447 305.785 204.129 305.537 204.812 305.304C204.424 305.863 204.036 306.406 203.664 306.948C202.145 309.182 200.78 311.368 199.54 313.54C206.812 319.061 213.526 322.162 217.821 321.868C219.139 321.775 220.24 321.371 221.046 320.596C225.403 316.471 219.976 303.521 208.828 290.556H208.843Z",
    fill: "url(#paint35_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M229.264 263.85C208.657 242.122 186.81 229.11 179.259 233.809C178.964 233.995 178.701 234.197 178.453 234.43C175.258 237.454 176.344 244.417 180.685 253.335C192.609 248.744 206.145 251.799 214.937 261.074L231.559 278.614C240.335 287.873 242.676 301.474 237.528 313.121C246.025 317.773 252.77 319.154 255.918 316.161C256.088 315.99 256.243 315.819 256.398 315.633C261.949 308.623 250.088 285.825 229.248 263.85H229.264Z",
    fill: "url(#paint36_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.396 84.1502V84.1657C456.016 101.566 457.644 125.558 453.334 150.621C453.132 151.753 452.931 152.885 452.714 154.032C452.714 154.032 452.714 154.048 452.714 154.063C452.497 155.196 452.264 156.328 452.016 157.46V157.491C451.768 158.623 451.52 159.771 451.241 160.903C451.241 160.903 451.241 160.903 451.241 160.918C450.884 162.438 450.496 163.958 450.078 165.478C450.078 165.509 450.062 165.54 450.047 165.586C449.752 166.688 449.442 167.789 449.116 168.89C449.101 168.952 449.085 169.014 449.054 169.076C448.729 170.146 448.403 171.216 448.062 172.286C448.062 172.317 448.031 172.364 448.031 172.395C442.092 150.558 421.951 121.418 401.98 100.341C382.009 79.265 356.58 59.1347 332.484 50.5118C382.195 37.3294 432.34 51.9541 444.666 56.095C446.496 56.6998 447.891 58.1886 448.403 60.0342C448.403 60.0342 450.636 67.9901 451.132 70.4095C451.876 74.023 453.396 84.1192 453.396 84.1192V84.1502Z",
    fill: "url(#paint37_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M220.984 133.747C220.953 133.716 220.922 133.67 220.875 133.639C218.952 131.979 211.479 137.81 208.595 135.469C206.936 134.119 207.742 130.816 208.874 125.217C210.641 116.455 211.68 111.291 211.99 108.173C212.052 107.491 212.083 106.917 212.083 106.405C212.021 96.4797 205.245 85.36 196.314 82.7235C195.027 82.3358 193.461 82.3358 191.275 82.5839C190.794 82.6304 190.298 82.708 189.756 82.7855C188.174 83.0181 186.298 83.3438 184.034 83.7316C183.894 83.7626 183.693 83.7936 183.445 83.8401C183.801 84.4139 184.36 84.7861 185.181 85.0343C185.972 85.2824 187.833 85.7167 188.717 85.8407C188.918 85.8718 189.104 85.9028 189.29 85.9338C192.081 86.4146 192.05 87.1435 192.05 87.1435C190.763 87.7948 189.259 88.3066 187.647 88.6943C179.119 90.757 167.567 89.4698 167.955 88.989C168.249 88.6323 170.002 87.6708 171.893 86.6007C165.458 88.4617 157.752 91.2688 152.031 95.1305C142.479 101.567 144.573 103.939 134.618 110.003C127.749 114.191 119.097 119.277 109.902 116.594C104.026 114.873 100.289 110.655 98.4129 108.127C96.3352 108.763 94.2729 109.398 92.1952 110.05C91.699 112.221 89.3112 123.635 96.2886 133.514C104.413 145.022 118.663 145.193 122.539 145.239C142.402 145.472 154.791 129.095 156.295 127.032C156.962 128.366 157.783 130.211 158.388 132.46C159.055 134.957 159.458 137.919 159.101 141.207C158.326 148.356 154.31 153.319 150.17 158.468C143.766 166.408 141.844 164.92 137.828 170.984C132.199 179.467 135.285 183.422 129.92 189.796C123.749 197.131 115.903 196.371 115.934 199.426C115.981 203.629 130.928 210.127 139.657 204.948C145.332 201.582 143.58 196.139 149.953 190.385C156.372 184.585 161.288 187.268 170.079 183.375C173.537 181.84 175.847 180.056 177.584 178.102C182.825 172.178 182.902 164.563 194.33 156.731C195.632 155.847 196.935 155.041 198.237 154.312C204.3 150.9 210.192 148.853 214.89 144.758C216.689 143.192 218.317 141.315 219.712 138.958C220.069 138.353 222.069 134.988 220.999 133.763L220.984 133.747Z",
    fill: "url(#paint38_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M104.506 144.014C105.173 143.921 105.654 143.3 105.561 142.618L86.241 1.05465C86.148 0.387776 85.5277 -0.092994 84.8455 5.82123e-05C84.1633 0.0931104 83.6981 0.713459 83.7911 1.39584L103.095 142.959C103.188 143.626 103.809 144.107 104.491 144.014H104.506Z",
    fill: "url(#paint39_linear_828_3004)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M92.5529 109.941C91.9947 107.475 91.0488 102.792 91.0488 100.078C91.0488 97.3637 101.5 96.2781 103.391 96.2781C105.283 96.2781 104.337 102.931 100.538 103.397C98.1968 103.691 97.6542 106.359 97.5921 108.375C95.3593 109.166 94.6926 109.274 92.5529 109.926V109.941Z",
    fill: "url(#paint40_linear_828_3004)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_828_3004",
    x1: 296.108,
    y1: 177.404,
    x2: 232.886,
    y2: 143.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_828_3004",
    x1: 60.317,
    y1: 193.781,
    x2: 231.109,
    y2: 179.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_828_3004",
    x1: 62.6108,
    y1: 221.433,
    x2: 233.404,
    y2: 207.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_828_3004",
    x1: 495.616,
    y1: -0.511676,
    x2: 221.731,
    y2: 280.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_828_3004",
    x1: 264.322,
    y1: 416.936,
    x2: 287.9,
    y2: 264.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_828_3004",
    x1: 293.936,
    y1: 280.041,
    x2: 282.07,
    y2: 388.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_828_3004",
    x1: 404.367,
    y1: -20.3011,
    x2: 149.187,
    y2: 232.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_828_3004",
    x1: 254.77,
    y1: 197.488,
    x2: 102.491,
    y2: 204.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_828_3004",
    x1: 405.441,
    y1: -19.5599,
    x2: 150.252,
    y2: 233.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_828_3004",
    x1: 256.491,
    y1: 64.842,
    x2: 286.733,
    y2: 37.6305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_828_3004",
    x1: 239.605,
    y1: 264.609,
    x2: 239.947,
    y2: 251.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_828_3004",
    x1: 243.281,
    y1: 239.454,
    x2: 240.582,
    y2: 256.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_828_3004",
    x1: 330.871,
    y1: 15.881,
    x2: 194.237,
    y2: 99.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_828_3004",
    x1: 233.264,
    y1: 88.6438,
    x2: 211.014,
    y2: 146.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_828_3004",
    x1: 233.978,
    y1: 89.0657,
    x2: 211.784,
    y2: 146.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_828_3004",
    x1: 235.741,
    y1: 89.7604,
    x2: 213.546,
    y2: 147.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_828_3004",
    x1: 239.094,
    y1: 131.033,
    x2: 169.105,
    y2: 172.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_828_3004",
    x1: 238.981,
    y1: 130.646,
    x2: 168.781,
    y2: 171.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_828_3004",
    x1: 239.201,
    y1: 130.98,
    x2: 168.974,
    y2: 172.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_828_3004",
    x1: 239.207,
    y1: 130.913,
    x2: 168.895,
    y2: 172.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_828_3004",
    x1: 238.954,
    y1: 130.772,
    x2: 168.967,
    y2: 171.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_828_3004",
    x1: 239.008,
    y1: 130.599,
    x2: 168.695,
    y2: 172.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_828_3004",
    x1: 239.184,
    y1: 130.891,
    x2: 168.872,
    y2: 172.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_828_3004",
    x1: 249.281,
    y1: 234.228,
    x2: 214.692,
    y2: 163.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_828_3004",
    x1: 64.3633,
    y1: 170.503,
    x2: 238.327,
    y2: -18.0934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_828_3004",
    x1: 184.018,
    y1: 103.691,
    x2: 178,
    y2: 80.4907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_828_3004",
    x1: 205.293,
    y1: 90.7258,
    x2: 173.78,
    y2: 62.1188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_828_3004",
    x1: -0.000554099,
    y1: 45.6887,
    x2: 93.3888,
    y2: 45.6887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EDD5",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06EDD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_828_3004",
    x1: 408.552,
    y1: 228.691,
    x2: 326.296,
    y2: 154.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_828_3004",
    x1: 229.554,
    y1: 65.0952,
    x2: 401.419,
    y2: 223.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_828_3004",
    x1: 5.28732,
    y1: 361.043,
    x2: 165.609,
    y2: 289.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_828_3004",
    x1: 75.2631,
    y1: 457.801,
    x2: 193.688,
    y2: 335.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_828_3004",
    x1: 135.548,
    y1: 213.028,
    x2: 248.729,
    y2: 318.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_828_3004",
    x1: 166.513,
    y1: 323.791,
    x2: 219.597,
    y2: 277.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_828_3004",
    x1: 168.342,
    y1: 320.332,
    x2: 220.217,
    y2: 274.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_828_3004",
    x1: 179.507,
    y1: 311.043,
    x2: 235.229,
    y2: 259.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_828_3004",
    x1: 120.71,
    y1: 352.621,
    x2: 289.422,
    y2: 217.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_828_3004",
    x1: 332.469,
    y1: 108.778,
    x2: 456.001,
    y2: 108.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EDD5",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06EDD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_828_3004",
    x1: -2375.55,
    y1: 2128.32,
    x2: 748.035,
    y2: -339.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_828_3004",
    x1: 106.755,
    y1: 154.544,
    x2: 96.4083,
    y2: 83.9338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_828_3004",
    x1: 104.678,
    y1: 92.1373,
    x2: 92.6275,
    y2: 105.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_828_3004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 456,
    height: 423,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.c536898060b16ad40b0a8bd6a324521f.svg";
export { ForwardRef as ReactComponent };